import { LEGAL_EFFECTIVE, PRIVACY_SECTIONS } from '../content/legal';

function renderBody(body: string) {
  return body.split('\n\n').map((para, i) => {
    const parts = para.split(/\*\*(.*?)\*\*/g);
    return (
      <p key={i}>
        {parts.map((p, j) => (j % 2 === 1 ? <strong key={j}>{p}</strong> : p))}
      </p>
    );
  });
}

export function PrivacyPage() {
  return (
    <>
      <section className="border-b border-line px-6 pt-28 pb-10 lg:px-10 lg:pt-36">
        <div className="mx-auto max-w-[1280px]">
          <p className="mb-3 text-[0.72rem] font-bold tracking-widest text-brand uppercase">Legal</p>
          <h1 className="font-display mb-3 text-[2.5rem] font-extrabold text-ink">Privacy Policy</h1>
          <p className="text-[1.05rem] text-ink-3">
            Effective {LEGAL_EFFECTIVE}. How cevop collects, uses, and protects your data.
          </p>
        </div>
      </section>
      <section className="px-6 py-12 lg:px-10">
        <div className="mx-auto grid max-w-[1280px] gap-10 lg:grid-cols-[220px_1fr]">
          <nav className="text-sm lg:sticky lg:top-24 lg:self-start" aria-label="Privacy sections">
            {PRIVACY_SECTIONS.map((s) => (
              <a key={s.id} href={`#${s.id}`} className="block py-1 text-ink-3 hover:text-brand">
                {s.title}
              </a>
            ))}
          </nav>
          <article className="prose">
            {PRIVACY_SECTIONS.map((s) => (
              <section key={s.id} id={s.id} className="scroll-mt-24">
                <h2>{s.title}</h2>
                {renderBody(s.body)}
              </section>
            ))}
          </article>
        </div>
      </section>
    </>
  );
}
